import { usePlan } from "@/hooks/use-plan";
import { SidebarData } from "../../types";

interface useSidebarRenderingByPlanProps {
  sidebarData: SidebarData
}

const useSidebarRenderingByPlan = ({ sidebarData }: useSidebarRenderingByPlanProps) => {
  const { plan } = usePlan()
  const planType = plan?.type || 'community'

  const filteredSidebarDataByPlanType = (sidebarData?.navGroups || [])
    .map(group => {
      const filteredItems = group.items
        .filter(item => !item.plans || item.plans.includes(planType))
        .map(item => {
          if ('items' in item && item.items) {
            const filteredSubItems = item.items.filter(
              subItem => !subItem.plans || subItem.plans.includes(planType)
            );
            return { ...item, items: filteredSubItems };
          }
          return item;
        });
      return { ...group, items: filteredItems };
    });

  return { filteredSidebarDataByPlanType }
}

export default useSidebarRenderingByPlan;